import styled from 'styled-components';

export const Section = styled.div`
  background: #111;
  border: 2px solid #061;
  overflow: hidden;
  border-radius: 12px;
`;
